module.exports = __webpack_public_path__ + "static/media/sap-logo-charcoal.ca5e63b3.svg";